import styled, { css } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
export const getBadgesBoundBoxSize = (size) => size === 'large' ? '24px' : '8px';
const getBadgesSize = (props) => {
    if (props.children) {
        return '24px';
    }
    else {
        switch (props.variant) {
            case 'negative':
                return '0px';
            case 'informative':
            case 'notice':
            case 'positive':
            default:
                return '8px';
        }
    }
};
const getBadgesColor = (props) => {
    switch (props.variant) {
        case 'positive':
            return props.theme.colors.ui.success;
        case 'notice':
            return props.theme.colors.ui.pending;
        case 'negative':
            return 'transparent';
        case 'informative':
        default:
            return props.theme.colors.ui.highlight.primary;
    }
};
const getBadgesCorners = (props) => {
    if (props.children) {
        return '100%';
    }
    else {
        switch (props.variant) {
            case 'notice':
            case 'negative':
                return '0%';
            case 'informative':
            case 'positive':
            default:
                return '100%';
        }
    }
};
const getBadgesTransform = (props) => {
    if (props.children) {
        return 'rotate(0deg)';
    }
    else {
        switch (props.variant) {
            case 'notice':
                return 'rotate(45deg)';
            case 'negative':
                return 'translateY(-0.5px)';
            case 'informative':
            case 'positive':
            default:
                return '';
        }
    }
};
const getBadgesBorderWidth = (props) => {
    if (props.children) {
        return '0px';
    }
    else {
        switch (props.variant) {
            case 'negative':
                return '0px 5px 9px 5px';
            case 'informative':
            case 'positive':
            case 'notice':
            default:
                return '0px';
        }
    }
};
const getBadgesBorderColor = (props) => {
    if (props.children) {
        return 'transparent';
    }
    else {
        switch (props.variant) {
            case 'negative':
                return `transparent transparent var(${props.theme.colors.ui.error}) transparent`;
            case 'informative':
            case 'positive':
            case 'notice':
            default:
                return 'transparent';
        }
    }
};
export const StyledBadgeShape = styled.span.withConfig({ displayName: "auir-41e20d9-StyledBadgeShape", componentId: "auir-41e20d9-1w5nauw" }) `
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;

  ${(props) => {
    const size = getBadgesBoundBoxSize(props.children ? 'large' : 'small');
    return css `
      width: ${size};
      height: ${size};
    `;
}}

  ${injectSpacing('margin')}

  &::before {
    content: '';
    position: absolute;
    width: ${(props) => getBadgesSize(props)};
    height: ${(props) => getBadgesSize(props)};

    line-height: 0;
    text-align: center;

    background-color: var(
      ${(props) => props.children
    ? props.theme.colors.ui.highlight.primary
    : getBadgesColor(props)}
    );

    border-color: ${(props) => getBadgesBorderColor(props)};
    border-style: solid;
    border-width: ${(props) => getBadgesBorderWidth(props)};
    border-radius: ${(props) => getBadgesCorners(props)};

    transform: ${(props) => getBadgesTransform(props)};
  }
`;
export const StyledBadgeCount = styled.span.withConfig({ displayName: "auir-41e20d9-StyledBadgeCount", componentId: "auir-41e20d9-imcbfq" }) `
  z-index: 1;
  color: var(${(props) => props.theme.colors.ui.inverted});

  ${(props) => injectTypography(props, props.count && props.count <= 100 ? 'copy2' : 'copy3')}
`;
export const StyledBadgeExclamationMark = styled.span.withConfig({ displayName: "auir-41e20d9-StyledBadgeExclamationMark", componentId: "auir-41e20d9-jy6ifn" }) `
  z-index: 1;
  color: var(${(props) => props.theme.colors.ui.inverted});

  ${(props) => injectTypography(props, 'copy2')}
`;
export const StyledBadgeLayout = styled.span.withConfig({ displayName: "auir-41e20d9-StyledBadgeLayout", componentId: "auir-41e20d9-14yu93l" }) `
  display: inline-flex;
  align-items: start;
  flex-direction: ${(props) => ({ end: 'row', start: 'row-reverse' }[props.labelAlignment])};
  gap: var(${(props) => props.theme.responsive.spacing.xs});

  ${injectSpacing('margin')}
`;
export const StyledBadgeLayoutBadgeShape = styled.div.withConfig({ displayName: "auir-41e20d9-StyledBadgeLayoutBadgeShape", componentId: "auir-41e20d9-aq061v" }) `
  display: flex;
  align-items: center;
  flex-grow: 0;

  min-height: var(
    ${(props) => props.theme.responsive.typography.copy2.lineHeight}
  );
`;
export const StyledBadgeLayoutLabel = styled.div.withConfig({ displayName: "auir-41e20d9-StyledBadgeLayoutLabel", componentId: "auir-41e20d9-1mrwfej" }) `
  text-align: ${(props) => ({ end: 'start', start: 'end' }[props.labelAlignment])};
  word-break: break-word;

  ${(props) => css `
    /** Negative values for padding are automatically clamped to 0. */
    padding-block-start: calc(
      ${getBadgesBoundBoxSize(props.badgeShapeSize)} / 2 -
        var(${props.theme.responsive.typography.copy2.lineHeight}) / 2
    );
  `}
`;
//# sourceMappingURL=Badge.styles.mjs.mjs.map